import * as Sentry from "@sentry/react";
import React from "react";
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes
} from "react-router-dom";
import { logger } from "./utils/logger";

/**
 * Initializes Sentry SDK.
 * @param allowedApplicationModes An array of allowed application modes.
 */
export const initializeSentry = (allowedApplicationModes: string[]): void => {
    const applicationMode = import.meta.env.MODE;
    const canInitializeSentry = allowedApplicationModes.includes(applicationMode);
    const sentryDsn = import.meta.env.SENTRY_DSN || "https://c86fa39acd64f7c37ee04594893a6d4b@o4507508262961152.ingest.de.sentry.io/4508494957051984";

    if (!canInitializeSentry) {
        logger.info(`Application is running in mode "${applicationMode}", not initializing Sentry.`);
        return;
    }

    Sentry.init({
        dsn: sentryDsn,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes
            }),
            Sentry.httpClientIntegration({ failedRequestStatusCodes: [[400, 599]] }),
            Sentry.captureConsoleIntegration({ levels: ['error'] })
        ],
        tracesSampleRate: 1.0,
        environment: import.meta.env.MODE,
        release: APP_VERSION,
        sendDefaultPii: true,
    });
}
